<template>
  <svg v-if="color_1"
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 3.6C3 3.44087 3.06321 3.28826 3.17574 3.17574C3.28826 3.06321 3.44087 3 3.6 3H20.4C20.5591 3 20.7117 3.06321 20.8243 3.17574C20.9368 3.28826 21 3.44087 21 3.6V17.4C21 17.4788 20.9845 17.5568 20.9543 17.6296C20.9242 17.7024 20.88 17.7685 20.8243 17.8243C20.7685 17.88 20.7024 17.9242 20.6296 17.9543C20.5568 17.9845 20.4788 18 20.4 18H16.26C16.1779 17.9999 16.0967 18.0166 16.0214 18.0491C15.9461 18.0816 15.8782 18.1292 15.822 18.189L12.437 21.786C12.3809 21.8456 12.3132 21.8931 12.238 21.9256C12.1629 21.9581 12.0819 21.9749 12 21.9749C11.9181 21.9749 11.8371 21.9581 11.762 21.9256C11.6868 21.8931 11.6191 21.8456 11.563 21.786L8.178 18.189C8.1218 18.1292 8.05393 18.0816 7.97859 18.0491C7.90325 18.0166 7.82205 17.9999 7.74 18H3.6C3.44087 18 3.28826 17.9368 3.17574 17.8243C3.06321 17.7117 3 17.5591 3 17.4V3.6Z"
      stroke="url(#ai_group_icon)"
      stroke-width="1.5" />
    <path
      d="M12 7L13.425 9.575L16 11L13.425 12.425L12 15L10.575 12.425L8 11L10.575 9.575L12 7Z"
      stroke="url(#ai_group_icon)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <defs>
      <linearGradient id="ai_group_icon"
                      x1="12"
                      y1="3"
                      x2="12"
                      y2="21.9749"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color_1" />
        <stop offset="1" :stop-color="color_2" />
      </linearGradient>
      <linearGradient id="ai_group_icon"
                      x1="12"
                      y1="7"
                      x2="12"
                      y2="15"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color_1" />
        <stop offset="1" :stop-color="color_2" />
      </linearGradient>
    </defs>
  </svg>

  <svg v-else
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 3.6C3 3.44087 3.06321 3.28826 3.17574 3.17574C3.28826 3.06321 3.44087 3 3.6 3H20.4C20.5591 3 20.7117 3.06321 20.8243 3.17574C20.9368 3.28826 21 3.44087 21 3.6V17.4C21 17.4788 20.9845 17.5568 20.9543 17.6296C20.9242 17.7024 20.88 17.7685 20.8243 17.8243C20.7685 17.88 20.7024 17.9242 20.6296 17.9543C20.5568 17.9845 20.4788 18 20.4 18H16.26C16.1779 17.9999 16.0967 18.0166 16.0214 18.0491C15.9461 18.0816 15.8782 18.1292 15.822 18.189L12.437 21.786C12.3809 21.8456 12.3132 21.8931 12.238 21.9256C12.1629 21.9581 12.0819 21.9749 12 21.9749C11.9181 21.9749 11.8371 21.9581 11.762 21.9256C11.6868 21.8931 11.6191 21.8456 11.563 21.786L8.178 18.189C8.1218 18.1292 8.05393 18.0816 7.97859 18.0491C7.90325 18.0166 7.82205 17.9999 7.74 18H3.6C3.44087 18 3.28826 17.9368 3.17574 17.8243C3.06321 17.7117 3 17.5591 3 17.4V3.6Z"
      stroke="url(#ai_group_icon_2)"
      stroke-width="1.5" />
    <path
      d="M12 7L13.425 9.575L16 11L13.425 12.425L12 15L10.575 12.425L8 11L10.575 9.575L12 7Z"
      stroke="url(#ai_group_icon_2)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <defs>
      <linearGradient id="paint0_linear_251_86"
                      x1="12"
                      y1="3"
                      x2="12"
                      y2="21.9749"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color" />
        <stop offset="1" :stop-color="color" />
      </linearGradient>
      <linearGradient id="ai_group_icon_2"
                      x1="12"
                      y1="7"
                      x2="12"
                      y2="15"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color" />
        <stop offset="1" :stop-color="color" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "white"
    },
    color_1: null,
    color_2: null
  }
}
</script>
